import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiPermissionsRegistry } from '@/entities/permissions/modules/api/permissions';

export const usePermissionsRegistry = (enabled = true) =>
  useFetch({
    api: apiPermissionsRegistry,
    keywords: queryKeys.permissions.registry,
    enabled,
    // Registry is effectively static for a session — cache hard.
    staleTime: 60 * 60 * 1000,
  });
